import React from 'react';
import clsx from 'clsx';
import styles from './IconButtonsControl.module.css';

interface Props {
  positioningClassName?: string;
  buttons: {
    iconUrl: string;
    onClick?: () => void;
  }[];
}

export class IconButtonsControl extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <div className={clsx(styles.control, this.props.positioningClassName)}>
        {this.props.buttons.map((button, key) => (
          <div
            key={key}
            className={clsx(styles.button)}
            style={{ backgroundImage: `url(${button.iconUrl})` }}
            onClick={button.onClick}
          />
        ))}
      </div>
    );
  }
}
